import { MvcContainer } from './mvc-container';

export abstract class ModelBase extends MvcContainer {

}
